import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { RefreshCw } from "lucide-react";
import { useAuth } from "../AuthContext";
import { getLang } from "./i18n";

const KEY = "pulse_next";

// next accepts ONLY internal /pulse or /events paths (anti open-redirect guard).
const isValidNext = (v) =>
  typeof v === "string" && (v.startsWith("/pulse") || v.startsWith("/events")) && !v.startsWith("//") && !v.includes("://");

export function savePulseNext(path) {
  try {
    if (isValidNext(path)) localStorage.setItem(KEY, path);
  } catch { /* private mode — cross-device fallback: land on /pulse */ }
}

// One-shot: cleared immediately on read.
export function consumePulseNext() {
  try {
    const v = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    return isValidNext(v) ? v : null;
  } catch {
    return null;
  }
}

/** Client gate for deep Pulse routes: anonymous visitors never dead-end —
 *  the requested path is stored (localStorage, one-shot) and they land on
 *  the public teaser; after login they resume on the requested page. */
export default function PulseGate({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <RefreshCw className="w-5 h-5 animate-spin text-[#006874]" />
      </div>
    );
  }
  if (!user) {
    savePulseNext(location.pathname + location.search);
    const lang = getLang(location.search);
    return <Navigate to={lang === "it" ? "/pulse?lang=it" : "/pulse"} replace />;
  }
  return children;
}
